import { useState, useEffect } from "react";
import { Stack, Typography, Autocomplete, TextField } from "@mui/material";
import LeadershipBonusesShell from "../Shell/LeadershipBonuseShell";
import useFetchAgentsOptions from "../../../sharedhooks/Agents/useFetchAllAgents";
import useApproveRejectMilestone from "../hooks/useApproveRejectMilestone";

export default function AdminLeadershipBonuses() {
	const [currentAgent, setCurrentAgent] = useState(null);
	const { agents, loading: agentOptionsLoading } = useFetchAgentsOptions();

	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;

	const { approveReject: approveRejectRaw, loading: approveRejectLoading } = useApproveRejectMilestone();

	// Inject the approving admin's ID so the shell doesn't need to know about auth/localStorage.
	const approveReject = (payload) => approveRejectRaw({ ...payload, approved_by: user?.ID });

	useEffect(() => {
		if (agents?.length > 0 && !currentAgent) {
			setCurrentAgent(agents[0]);
		}
	}, [agents, currentAgent]);

	const header = (
		<Stack
			direction={{ xs: "column", sm: "row" }}
			alignItems={{ xs: "flex-start", sm: "center" }}
			spacing={{ xs: 0.75, sm: 2 }}
			width={{ xs: "100%", lg: "auto" }}
		>
			<Typography fontWeight={600} sx={{ fontSize: { xs: 13, sm: 14 }, whiteSpace: "nowrap" }}>
				Current Agent:
			</Typography>
			<Autocomplete
				size="small"
				options={agents || []}
				loading={agentOptionsLoading}
				value={currentAgent}
				onChange={(e, newValue) => setCurrentAgent(newValue)}
				getOptionLabel={(option) => option?.display_name || ""}
				isOptionEqualToValue={(option, value) => option?.ID === value?.ID}
				sx={{
					width: { xs: "100%", sm: 220, md: 250 },
					"& .MuiButtonBase-root": {
						backgroundColor: "transparent",
						"&:hover": { color: "#1D54A2" },
					},
				}}
				slotProps={{
					popper: {
						sx: { "& .MuiAutocomplete-paper": { width: "inherit !important" } },
					},
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder="Select agent"
						sx={{
							"& .MuiInputBase-input": { padding: { xs: "6px 10px", sm: "8.5px 14px" }, fontSize: { xs: 13, sm: 14 } },
							"& fieldset": { borderColor: "#4E4E4E !important" },
							"&:hover fieldset": { borderColor: "#4E4E4E !important" },
							"&.Mui-focused fieldset": { borderColor: "#4E4E4E !important" },
							"& .MuiAutocomplete-input": { border: "none !important" },
						}}
					/>
				)}
			/>
		</Stack>
	);

	return (
		<LeadershipBonusesShell
			activeAgentId={currentAgent?.ID}
			activeAgentName={currentAgent?.display_name}
			headerSlot={header}
			isAgent={false}
			approveReject={approveReject}
			approveRejectLoading={approveRejectLoading}
		/>
	);
}
